const stack = []
let suppressPop = false
let initialized = false
let viewHistorySeq = 0

function isViewEntry (id) {
  return String(id).startsWith('view:')
}

function handlePopState () {
  if (suppressPop) {
    suppressPop = false
    return
  }
  const item = stack.pop()
  if (item && typeof item.onPopClose === 'function') {
    item.onPopClose()
  }
}

function ensureInitialized () {
  if (initialized || typeof window === 'undefined') return
  initialized = true
  window.addEventListener('popstate', handlePopState)
}

function pushHistoryEntry (id, onPopClose) {
  ensureInitialized()
  stack.push({ id, onPopClose })
  if (window.history && window.history.pushState) {
    window.history.pushState({ bgNav: id }, '', window.location.href)
  }
}

export function openOverlayHistory (id, onPopClose) {
  if (!id || typeof onPopClose !== 'function') return

  const top = stack[stack.length - 1]
  if (top && top.id === id) return

  pushHistoryEntry(id, onPopClose)
}

export function openViewHistory (onPopClose) {
  if (typeof onPopClose !== 'function') return
  viewHistorySeq += 1
  pushHistoryEntry(`view:${viewHistorySeq}`, onPopClose)
}

export function closeOverlayHistory (id) {
  const idx = stack.findIndex(item => item.id === id)
  if (idx === -1) return false

  const isTop = idx === stack.length - 1
  stack.splice(idx, 1)

  if (isTop && window.history && window.history.back) {
    suppressPop = true
    window.history.back()
  }

  return true
}

function removeHistoryEntries (predicate) {
  let count = 0
  for (let i = stack.length - 1; i >= 0; i -= 1) {
    if (predicate(stack[i])) {
      stack.splice(i, 1)
      count += 1
    }
  }
  return count
}

export function resetViewHistory () {
  const count = removeHistoryEntries(item => isViewEntry(item.id))
  if (!count || typeof window === 'undefined' || !window.history) return

  suppressPop = true
  window.history.go(-count)
}

export function resetOverlayHistory () {
  const count = stack.length
  if (!count || typeof window === 'undefined' || !window.history) {
    stack.length = 0
    return
  }

  stack.length = 0
  suppressPop = true
  window.history.go(-count)
}
